
/**
 * Module dependencies.
 */

import { ImageSource } from './media';

/**
 * Export `assetTypes`.
 */

export const assetTypes = {
  crypto: 'crypto',
  custom: 'custom',
  fiat: 'fiat'
};

/**
 * Export `AssetType` type.
 */

export type AssetType = keyof typeof assetTypes;

/**
 * Export `Asset` type.
 */

export type Asset = {
  baseRates: Array<BaseRate>;
  code: string;
  decimalPlaces: number | null | undefined;
  decimalPlacesToDisplay: number | null | undefined;
  enabled: boolean;
  logo: ImageSource | null | undefined;
  name: string;
  skipTrailingZeros: boolean | null | undefined;
  symbol: string | null | undefined;
  type: AssetType;
};

/**
 * Export `BaseRate` type.
 */

export type BaseRate = {
  quoteAssetCode: string;
  rate: string;
};
